import './Form.scss';

import * as React from 'react';
import { Prompt } from 'react-router-dom';

import { Button, Modal, Typography } from 'antd';
import clsx from 'clsx';

import { useBeforeUnload } from 'lib/hooks';

export interface FormProps {
  alwaysEnabledSubmit?: boolean;
  className?: string;
  isChanged?: boolean;
  warnUnsavedChanges?: boolean;
  leaveMessage?: string;
}

const leaveMessage = 'Discard unsaved changes?';

export function FormUnsavedChangesWrapper(
  props: React.PropsWithChildren<FormProps>
) {
  const isChanged = props.isChanged ?? false;
  useBeforeUnload(isChanged);

  return (
    <div className={clsx('form', props.className)}>
      {props.warnUnsavedChanges && (
        <Prompt
          message={() =>
            isChanged ? props.leaveMessage ?? leaveMessage : true
          }
        />
      )}
      {props.children}
    </div>
  );
}

export interface FormModalProps {
  visible: boolean;
  onClose: () => void;
  onGoto: () => void;
  gotoLabel: string;
}

export function FormModal({
  visible,
  onClose,
  onGoto,
  gotoLabel
}: FormModalProps) {
  return (
    <Modal
      open={visible}
      closable={false}
      footer={[
        <Button type="primary" key="Ok" onClick={onClose}>
          Ok
        </Button>,
        <Button key="back" onClick={onGoto}>
          {gotoLabel}
        </Button>
      ]}
    >
      <Typography.Paragraph>Your data was submitted.</Typography.Paragraph>
    </Modal>
  );
}
